import PropTypes from "prop-types";

type Props = {
  checked: boolean;
  onClick: () => void;
};

const ToggleSwitch = ({ checked, onClick }: Props) => {
  return (
    <label className="switch-btn mb-0">
      <input
        type="checkbox"
        checked={checked}
        onClick={() => {
          onClick();
        }}
        readOnly={true}
      />
      <span className="slider"></span>
    </label>
  );
};

ToggleSwitch.propTypes = {
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ToggleSwitch.defaultProps = {
  checked: false,
};

export default ToggleSwitch;
